export const cols = [{
	prop: 'type',
	label: '活动类型',
	width: '200',
	align: 'center'
}, {
	prop: 'discnt',
	label: '活动个数',
	width: '200',
	align: 'center'
}, {
	prop: 'useingdis',
	label: '有效活动个数',
	width: '200',
	align: 'center'
}, {
	prop: 'ordercnt',
	label: '成单量',
	width: '200',
	align: 'center'
}, {
	prop: 'disaftermoney',
	label: '成单额',
	width: '200',
	align: 'center'
}, {
	prop: 'totalprice',
	label: '折前额',
	width: '200',
	align: 'center'
}, {
	prop: 'discountprice',
	label: '打折额',
	width: '200',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'disrate',
	label: '折扣率',
	width: '200',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'buyercnt',
	label: '采购门店数',
	width: '200',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sellercnt',
	label: '供货商店铺数',
	width: '200',
	headerAlign: 'center',
	align: 'right'
}]
